// extracted by mini-css-extract-plugin
export default {"root":"oD8ucY0KBd6Wqf80HMMq","placeHolderShimmer":"uoubjZoIfdHb7cYRM8LA"};